export const TITLE_NEW_OBLIGATION = "Nueva obligación + FNG";
export const MESSAGE_NEW_OBLIGATION =
	"Incluye capital consolidado por $000.000,00 y primera comisión del Fondo Nacional de Garantías por $000.000,00 .";

export const TITLE_GRACE_PERIOD = "Periodo de gracia a capital";
export const MESSAGE_GRACE_PERIOD =
	"Cantidad de meses en que tu cuota es más baja. No abonas a capital, solo pagas intereses y seguro.";

  export const TITLE_FNG = "FNG";
  export const MESSAGE_FNG =
    "FNG: Fondo nacional de garantías.";

export const TITLE_CUOTA_GRACE = "Cuota durante el periodo de gracia";
export const MESSAGE_CUOTA_GRACE = "Durante el periodo de gracia tendrás una cuota con la que no abonas a capital, solo pagas intereses y seguro.​";

export const TITLE_LAST7_MONTHS = "Cuota después del periodo de gracia (mes 7)";
export const MESSAGE_LAST7_MONTHS =
	"El valor que pagas después del periodo de gracia ya incluye abono a capital, intereses y seguro.";

export const TITLE_TASA = "Tasa";
export const MESSAGE_TASA =
	"Tasa que tendrá tu nuevo crédito.​";

export const MESSAGE_PANT3 =
	"Estos valores están sujetos a cambios. Conoce los valores exactos al terminar el proceso de unificación.";

export const COLORS_CARDS = [
	"#F5B6CD",
	"#59CBE8",
	"#FDDA24",
	"#F5B6CD",
	"#59CBE8",
	"#FDDA24"
];

export const SCREEN_PIXELS: number = 992;
export const SCREEN_WIDTH: number = 1024;

export const MODEL_ALTERNATIVA = {
	packageName: "",
	creditsNumber: 0,
	feeDuringGracePeriod: "",
	newAmortizationDescription: "",
	details: {
		newConditions: {
			term: "",
			gracePeriod: "",
			newFee: "",
			feeAfterGracePeriod: "",
			unifiedValueFNG: "",
			feeFNG: "",
			newCapital: "",
			rate: ""
		},
		creditsIncluded: [
			{
				nameObligation: "",
				loanNumber: ""
			}
		]
	}
};
